module.exports = __webpack_public_path__ + "assets/birthday-cake.4a920c06.svg";